import { render, staticRenderFns } from "./TrainingIcon.vue?vue&type=template&id=13271634&"
import script from "./TrainingIcon.vue?vue&type=script&lang=js&"
export * from "./TrainingIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrainingIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VFadeTransition,VIcon})
